<template>
  <div
    v-if="mounted"
    class="title-bar"
  >
    <Teleport to=".bf-layout__buttons">
      <div class="title-bar__buttons">
        <slot></slot>
      </div>
    </Teleport>

    <h1>{{ title }}</h1>

    <slot name="measurements"></slot>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'

defineProps<{
  title?: string
}>()

const mounted = ref(false)

onMounted(() => {
  mounted.value = true
})
</script>

<style lang="scss" scoped>
.title-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2.4rem;
  margin-bottom: 2.4rem;

  h1 {
    margin: 0;
  }

  &__buttons {
    display: flex;
    justify-content: flex-end;
    gap: 0.8rem;
  }
}
</style>
